import { Script, injector } from '../shared/injector.js';
import { renderAIContent } from '../ai-ui/InsightAI.js';
injector.injectClass(class extends Script {
    async onLoad() {
        console.log('Rendering Single Story Capsule');
        await renderAIContent();
    }
}, ['news', 'ben-story', 'editorial-story']);
